import { PlatformFeeOrderType } from "./types"
import { capitalizeFirstLetter } from "src/shared/utils/data-helpers"
import { PlatformFeeType } from "src/graphql/quark/quark.type"

console.log("PlatformFeeOrderType", PlatformFeeOrderType)
export const PLATFORM_FEE_ORDER_TYPE_OPTIONS = [
  { value: PlatformFeeOrderType.Delivery, label: capitalizeFirstLetter(PlatformFeeOrderType.Delivery || "") },
  { value: PlatformFeeOrderType.Pickup, label: capitalizeFirstLetter(PlatformFeeOrderType.Pickup || "") },
  { value: PlatformFeeOrderType.Return, label: capitalizeFirstLetter(PlatformFeeOrderType.Return || "") }
]

export const PLATFORM_FEE_TYPE_OPTIONS = [
  { value: PlatformFeeType.Percentage, label: capitalizeFirstLetter(PlatformFeeType.Percentage) },
  { value: PlatformFeeType.Flat, label: capitalizeFirstLetter(PlatformFeeType.Flat) }
]

export const PLATFORM_FEE_TAXABLE_OPTIONS = [
  { value: true, label: "Yes" },
  { value: false, label: "No" }
]
